import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent, SnackbarErrorComponent, SnackbarSuccessComponent } from '../../app.component';

@Injectable()
export class NotificationService {
  durationInSeconds = 5;
  notification = '';
  constructor(private snackBar: MatSnackBar) {
  }

  customToast(message: string, action: string) {

    switch (action) {
      case 'Gelukt':
        this.snackBar.openFromComponent(SnackbarSuccessComponent, {
          data: message, duration: this.durationInSeconds * 1000,
        });
        break;
      case 'Oeps':
        this.snackBar.openFromComponent(SnackbarErrorComponent, {
          data: message, duration: this.durationInSeconds * 1000,
        });
        break;
      default:
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: message, duration: this.durationInSeconds * 1000,
        });
        break;
    }

  }

  commonErrorToast() {

    /*
    this._snackBar.open('Er ging iets mis! Probeer het opnieuw', 'Oeps', {
      duration: this.durationInSeconds * 1000,
    });
    */
    this.snackBar.openFromComponent(SnackbarErrorComponent, {
      data: 'Er ging iets mis! Probeer het opnieuw', duration: this.durationInSeconds * 1000,
    });
  }

  /*
  customToast(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: this.durationInSeconds * 1000,
    });
  }
  */



}
